module.exports = __webpack_public_path__ + "img/Card Pack Set.38e77f9a.png";